import { Box, Button, Typography } from "@mui/material";
import React from "react";
import logo from "../../Assets/Images/logo.png";
import login_bg from "../../Assets/Images/login-bg.png";
import LoginFrom from "../../Components/Login/LoginFrom";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate(); 
  return (
    <Box display={"flex"}  overflow={"hidden"}>
      <Box
        width={"62%"}
        display={"flex"}
        flexDirection={"column"}
        alignContent={"center"}
        justifyContent={"center"}
        sx={{
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
      >
        <Box marginBottom={5} textAlign={"center"}>
          <img src={logo} onClick={() => navigate("/")} style={{ cursor: 'pointer' }} width={80} height={74} />
        </Box>
        <Box textAlign={"center"} color={theme.colors.text}>
          <Typography variant="h5" fontWeight={600}>
            Welcome Back
          </Typography>
          <Typography variant="p" fontWeight={600} sx={{ mb: 2, display: 'block' }}>
            Enter Your Details
          </Typography>
        </Box>
        <Box>
          <LoginFrom />
        </Box>
      </Box>
      <Box
        width="35%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          "@media (max-width: 900px)": {
            display: "none",
          },
          "@media (min-width: 900px) and (max-width: 1200px)": {
            height: "20vh",
          },
          "@media (min-width: 900px)": {
            height: "90vh",
          },
        }}
      >
        <img
          src={login_bg}
          alt="Login Background"
          style={{ width: "100%", height: "100%"}}
        />
      </Box>
    </Box>
  );
}

export default Login;
